export default __webpack_public_path__ + "static/media/mint-logo-large.50f1bfc6.svg";